export default __webpack_public_path__ + "static/page_background-83892ee44be1eea6bf386c33c1776f4b.jpg";